// Central place for contact information
const contactInfo = {
    email: "me@lperron.com",
    gitlab: "https://gitlab.com/lperron/"
};

// Business/Legal information for legal documents
export const businessInfo = {
    name: "Lucas Perron",
    businessType: {
        en: "Sole Proprietor (Entrepreneur Individuel)",
        fr: "Entrepreneur Individuel (EI)"
    },
    siret: "99970061000010",
    phone: "06 45 29 23 77",
    address: {
        street: "6B rue des Capucins",
        city: "69001 Lyon",
        country: {
            en: "France",
            fr: "France"
        }
    },
    vatNotice: {
        en: "VAT not applicable, Article 293 B of the French General Tax Code.",
        fr: "TVA non applicable, article 293 B du Code Général des Impôts."
    }
};

// Hosting provider info
export const hostingInfo = {
    name: "Netlify, Inc.",
    address: {
        street: "44 Montgomery Street, Suite 300",
        city: "San Francisco, CA 94104",
        country: "USA"
    },
    website: "https://www.netlify.com"
};

// Labels for legal documents (bilingual)
export const legalLabels = {
    en: {
        siret: "SIRET:",
        phone: "Phone:",
        email: "Email:",
        website: "Website:",
        byEmail: "By email:",
        byPhone: "By phone:",
        byMail: "By mail:"
    },
    fr: {
        siret: "SIRET :",
        phone: "Téléphone :",
        email: "Email :",
        website: "Site web :",
        byEmail: "Par email :",
        byPhone: "Par téléphone :",
        byMail: "Par courrier :"
    }
};

export const { email, gitlab } = contactInfo;
export default contactInfo;